import { useEffect, useState } from "react";
import styled from "styled-components";
import { ArrowUpIcon } from "../TipSheetIcons/arrow-up.jsx";

const BarContainer = styled.div`
  display: flex;
  align-items: center;
  max-width: 2200px;
  margin-inline: auto;
`;

const BarWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 1000;
  background: #ffffff;
  border-bottom: 1px solid #cccccc;
  border-top: 1px solid #cccccc;
  overflow-x: auto;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  padding: 1rem 4rem;

  @media (max-width: 1440px) {
    padding: 1rem 2rem;
  }

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const TopButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin-right: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0a819f;

  &:hover,
  &:focus {
    color: #066676;
  }
`;

const Links = styled.nav`
  display: flex;
  gap: 1.25rem;
  @media (max-width: 767px) {
    display: none;
  }
  a {
    text-decoration: none;
    color: #0a819f;
    font-weight: 700;
    white-space: nowrap;
    transition: color 0.15s ease-in-out;
  }
  a:hover,
  a:focus {
    color: #066676;
    text-decoration: underline;
  }
`;

const MobileSelect = styled.select`
  flex: 1;
  padding: 0.5rem;
  font-size: 1rem;
  border: 1px solid #cccccc;
  border-radius: 4px;
  background: #ffffff;
  color: #0a819f;
  appearance: none;

  @media (min-width: 768px) {
    display: none;
  }
`;

export function UtilityBar({ sections = [] }) {
  // scroll to element with id
  const [activeSection, setActiveSection] = useState("");

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
      window.history.replaceState(null, "", `#${id}`);
      setActiveSection(id);
    }
  };

  const handleLinkClick = (e, id) => {
    e.preventDefault();
    scrollToSection(id);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setActiveSection("");
    window.history.replaceState(null, "", window.location.pathname + window.location.search);
  };

  useEffect(() => {
    const onHashChange = (ev) => {
      ev.preventDefault();
      const h = window.location.hash.replace("#", "");
      if (h) {
        const el = document.getElementById(h);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
        setActiveSection(h);
      }
    };
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  if (!sections || sections.length === 0) return null;

  return (
    <BarWrapper>
      <BarContainer>
        <TopButton onClick={scrollToTop} aria-label="Scroll to top">
          <ArrowUpIcon width={16} height={16} />
        </TopButton>
        <Links>
          {sections.map((s) => (
            <a
              key={s.value}
              href={`#${s.value}`}
              onClick={(e) => handleLinkClick(e, s.value)}
            >
              {s.label}
            </a>
          ))}
        </Links>
        <MobileSelect
          aria-label="Jump to section"
          value={activeSection}
          onChange={(e) => {
            const id = e.target.value;
            if (id) scrollToSection(id);
          }}
        >
          <option value="">Jump to section</option>
          {sections.map((s) => (
            <option key={s.value} value={s.value}>
              {s.label}
            </option>
          ))}
        </MobileSelect>
      </BarContainer>
    </BarWrapper>
  );
}
